import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
moment.locale("id");
export const TafaquhDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Detail Tafaquh", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Tafaquh",
      image: false,
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <div className="tw-rounded-lg card-body">
          <div className="tw-text-accent-primary tw-text-xs">Tanggal</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {moment(state.tanggal ?? Date.now()).format("dddd, DD MMMM YYYY")}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Nama Kitab</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.namaKitab ?? "-"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Materi</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.materi ?? "0"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Nilai Hafalan</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.hafalan ?? "-"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Nilai Makna</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.makna ?? "-"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Nilai Bacaan</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.bacaan ?? "-"}
          </div>

          <div className="tw-text-accent-primary tw-text-xs">Keterangan</div>
          <div className="tw-mb-4 tw-text-text-primary tw-font-semibold">
            {state.keterangan ?? "-"}
          </div>
        </div>
      </div>
    </>
  );
};
